import { DEFAULT_DECIMAL_PRECISION, formatDataValue, } from '@thoughtspot/number-format-util';
import { isDoubleColumn } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getColumnCurrencyInfo, getFormatPattern, getUniqueCurrencyCode, isEffectivelyPercent, } from '../column-format-util';
import { CurrencyFormatType } from '../types/prism';
import { singleObjectParamMemoize } from '../utils/cache';
export function mkNumericFormatterExpensive(col) {
    const formatPattern = getFormatPattern(col);
    const isDoubleCol = isDoubleColumn(col);
    const isPercentCol = isEffectivelyPercent(col);
    let shouldTryToGetCurrencyCodeFromDataValue = false;
    const currencyTypeInfo = getColumnCurrencyInfo(col);
    const currencyRef = currencyTypeInfo?.type === CurrencyFormatType.Column;
    let isCurrency = currencyRef || (currencyTypeInfo && !!currencyTypeInfo.type);
    let currencyCode;
    if (isCurrency &&
        currencyTypeInfo?.type !== CurrencyFormatType.UserLocale) {
        if (currencyTypeInfo?.type === CurrencyFormatType.IsoCode) {
            currencyCode = currencyTypeInfo?.isoCode;
        }
        else if (currencyRef) {
            shouldTryToGetCurrencyCodeFromDataValue = true;
            if (getUniqueCurrencyCode(col)) {
                currencyCode = getUniqueCurrencyCode(col);
            }
        }
        else {
            isCurrency = false;
        }
    }
    const shouldTryToGetCurrencyCodeFromDataValue_ = shouldTryToGetCurrencyCodeFromDataValue;
    const currencyCode_ = currencyCode;
    return (dataValue, additionalParams = {}) => {
        if (!_.has(additionalParams, 'isPercent')) {
            additionalParams.isPercent = isPercentCol;
        }
        let nDecimal = additionalParams.nDecimal;
        if (_.isUndefined(nDecimal) && isDoubleCol) {
            nDecimal = DEFAULT_DECIMAL_PRECISION;
        }
        let currencyCodeLocal = currencyCode_;
        if (shouldTryToGetCurrencyCodeFromDataValue_ &&
            Array.isArray(dataValue)) {
            [dataValue, currencyCodeLocal] = dataValue;
        }
        return formatDataValue(dataValue, {
            noShorten: additionalParams.noShorten,
            formatPattern,
            isPercent: additionalParams.isPercent,
            nDecimal: formatPattern ? undefined : nDecimal,
            isCurrency,
            currencyCode: currencyCodeLocal,
        });
    };
}
export const mkNumericFormatter = singleObjectParamMemoize(mkNumericFormatterExpensive);
export function numericFormatter(col, dataValue, additionalParams = {}) {
    if (!_.has(additionalParams, 'isDouble')) {
        additionalParams.isDouble = isDoubleColumn(col);
    }
    if (!_.has(additionalParams, 'isPercent')) {
        additionalParams.isPercent = isEffectivelyPercent(col);
    }
    const currencyTypeInfo = getColumnCurrencyInfo(col);
    const currencyRef = currencyTypeInfo?.type === CurrencyFormatType.Column;
    let isCurrency = currencyRef || (currencyTypeInfo && !!currencyTypeInfo.type);
    let currencyCode;
    if (isCurrency &&
        currencyTypeInfo?.type !== CurrencyFormatType.UserLocale) {
        if (currencyTypeInfo?.type === CurrencyFormatType.IsoCode) {
            currencyCode = currencyTypeInfo?.isoCode;
        }
        else if (currencyRef) {
            if (Array.isArray(dataValue)) {
                currencyCode = dataValue[1];
                dataValue = dataValue[0];
            }
            else if (getUniqueCurrencyCode(col)) {
                currencyCode = getUniqueCurrencyCode(col);
            }
            else {
                isCurrency = false;
            }
        }
        else {
            isCurrency = false;
        }
    }
    let nDecimal = additionalParams.nDecimal;
    const formatPattern = getFormatPattern(col);
    if (_.isUndefined(nDecimal) && isDoubleColumn(col)) {
        nDecimal = DEFAULT_DECIMAL_PRECISION;
    }
    return formatDataValue(dataValue, {
        noShorten: additionalParams.noShorten,
        formatPattern,
        isPercent: additionalParams.isPercent,
        nDecimal: formatPattern ? undefined : nDecimal,
        isCurrency,
        currencyCode,
    });
}
function mkFloatingPointFormatterExpensive(col) {
    const numericFormatterr = mkNumericFormatter(col);
    return (dataValue, additionalParams = {}) => {
        return numericFormatterr(dataValue, {
            ...additionalParams,
            nDecimal: _.get(additionalParams, 'nDecimal', DEFAULT_DECIMAL_PRECISION),
        });
    };
}
export const mkFloatingPointFormatter = singleObjectParamMemoize(mkFloatingPointFormatterExpensive);
//# sourceMappingURL=generic-value-formatters.js.map